import { render, staticRenderFns } from "./RedaSwitch.vue?vue&type=template&id=101a6c52&scoped=true"
import script from "./RedaSwitch.vue?vue&type=script&lang=js"
export * from "./RedaSwitch.vue?vue&type=script&lang=js"
import style0 from "./RedaSwitch.vue?vue&type=style&index=0&id=101a6c52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101a6c52",
  null
  
)

export default component.exports